import { createActions } from 'redux-actions';

export const actions = createActions({
  DOCUMENT: {
    SET_DOCUMENTS: (items) => items,
    SET_SEARCH_INDEX: (index) => index,
  },
}).document;
